export default __webpack_public_path__ + "static/media/header2.caf1cb30.jpg";